export default function px2rem(px) {
  // 设计稿宽度的1/10，此处值与postcssrc.js中rootValue值保持一致
  var rootValue = 37.5;
  return `${parseFloat(px) / rootValue}rem`;
}



// WEBPACK FOOTER //
// ./src/assets/js/px2rem.js